import { Injectable } from '@angular/core';

export type orgStructColors = {
  orgStructNameColor: string,
  orgStructDepartmentColor: string,
  orgStructBgColor: string,
  orgStructBorderColor: string,
  orgStructSubbordinateBgColor: string,
  orgStructSubbordinateTextColor: string,
  orgStructInitialsBgColor: string,
  orgStructInitialsTextColor: string,
}

@Injectable({
  providedIn: 'root'
})
export class OrgStructureServService {
  
  orgStructDefaultColors = {
    orgStructNameColor: '#000000',
    orgStructDepartmentColor: '#606060',
    orgStructBgColor: '#fafafa',
    orgStructBorderColor: '#F6921E',
    orgStructSubbordinateBgColor: '#F6921E',
    orgStructSubbordinateTextColor: '#ffffff',
    orgStructInitialsBgColor: '#808080',
    orgStructInitialsTextColor: '#ffffff'
  }

  constructor() { }
}
